export const APP_NAME = import.meta.env.VITE_APP_NAME || 'Pixgen'

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api'

/** 앱 베이스 경로 (로컬 '/', 프로덕션 '/image/') — 리다이렉트 시 앱 밖으로 나가지 않도록 사용 */
export const APP_BASE_PATH = import.meta.env.BASE_URL

/** 계정 출처(source)별 웍스 포탈. 이 배포의 포탈은 `/api/config` 의 loginUrl 이 알려준다. */
export const WRKS_PORTAL_URLS = { gov: 'https://gov.wrks.ai/', wrks: 'https://wrks.ai/' } as const

/**
 * 사용자가 선택한 스타일 ID (null이면 스타일 없음)
 * 스타일 목록은 DB에서 관리 (GET /api/generate/styles)
 */
export type StyleId = string | null

export const DEFAULT_STYLE_ID: StyleId = null

// 라벨은 i18n 키로 관리한다 (값은 locales/*.json 의 aspectRatios.*)
export const ASPECT_RATIO_GROUPS = [
  {
    labelKey: 'aspectRatios.groups.landscape',
    ratios: [
      { id: '21:9', labelKey: 'aspectRatios.21:9' },
      { id: '16:9', labelKey: 'aspectRatios.16:9' },
      { id: '4:3', labelKey: 'aspectRatios.4:3' },
      { id: '3:2', labelKey: 'aspectRatios.3:2' },
    ],
  },
  {
    labelKey: 'aspectRatios.groups.square',
    ratios: [
      { id: '1:1', labelKey: 'aspectRatios.1:1' },
    ],
  },
  {
    labelKey: 'aspectRatios.groups.portrait',
    ratios: [
      { id: '9:16', labelKey: 'aspectRatios.9:16' },
      { id: '3:4', labelKey: 'aspectRatios.3:4' },
      { id: '2:3', labelKey: 'aspectRatios.2:3' },
    ],
  },
  {
    labelKey: 'aspectRatios.groups.flexible',
    ratios: [
      { id: '5:4', labelKey: 'aspectRatios.5:4' },
      { id: '4:5', labelKey: 'aspectRatios.4:5' },
    ],
  },
] as const

export type AspectRatio = typeof ASPECT_RATIO_GROUPS[number]['ratios'][number]['id']

/**
 * AI 모델 ID 타입
 * 실제 데이터는 백엔드 API에서 가져옴 (GET /api/generate/models)
 * 기본 모델은 백엔드에서 isDefault: true로 지정
 */
export type ModelId = string
